import * as React from 'react'

const SvgTimeIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 7.33333V12L15.5 15.5M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12Z"
      stroke="url(#paint0_linear_1081_3530)"
      strokeWidth="2.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1081_3530"
        x1="3.32609"
        y1="2.71387"
        x2="16.4146"
        y2="18.0394"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.135417" stopColor="#FF692E" />
        <stop offset="1" stopColor="#FF692E" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgTimeIcon
